import {Component, OnInit} from '@angular/core';
import {Building} from '../building/building.model';
import {DatagridBaseComponent} from './datagrid.component';
import {Floor} from '../floor/floor.model';
import {Room} from '../room/room.model';
import {RequestParams} from '@ngx-ivengi/crud';
import {DatagridService} from './datagrid.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/first';

@Component({
  selector: 'app-datagrid-employee',
  templateUrl: './datagrid.component.html'
})
export class DatagridEmployeeComponent extends DatagridBaseComponent implements OnInit {

  public onFilterOptionsFinished: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    protected datagridService: DatagridService
  ) {
    super();
  }

  public ngOnInit(): void {

    // configure the "search" part, enable specific fields.
    this.datagridSearchComponent.config.filters.owner.enabled               = true;
    this.datagridSearchComponent.config.filters.customer.enabled            = true;
    this.datagridSearchComponent.config.filters.building.enabled            = true;
    this.datagridSearchComponent.config.filters.floor.enabled               = true;
    this.datagridSearchComponent.config.filters.room.enabled                = true;
    this.datagridSearchComponent.config.filters.mechanic.enabled            = true;
    this.datagridSearchComponent.config.filters.warrantyStatus.enabled      = true;
    this.datagridSearchComponent.config.filters.channelStatus.enabled       = true;
    this.datagridSearchComponent.config.filters.channelNumbers.enabled      = true;
    this.datagridSearchComponent.config.filters.location.enabled            = true;
    this.datagridSearchComponent.config.filters.remarks.enabled             = true;
    this.datagridSearchComponent.config.filters.dateFrom.enabled            = true;
    this.datagridSearchComponent.config.filters.dateTill.enabled            = true;
    this.datagridSearchComponent.config.filters.throughputType.enabled      = true;
    this.datagridSearchComponent.config.filters.maintenance.enabled         = true;
    this.datagridSearchComponent.config.filters.assignment.enabled          = true;

    // add the filter's options
    this.constructFilterOptions();

    // configure the "list" part

    this.datagridListComponent.config.enabledColumns = [
      'building.name',
      'floor.name',
      'channel.label',
      'assignment.date',
      'assignment.mechanic',
      'channel.throughputCount',
      'channel.dimension',
      'channel.location',
      'channel.finish',
      'channel.remarks',
      'channel.internalRemarks',
      'roomFrom.name',
      'roomTo.name'
    ];

    // bind onSelect methods
    this.datagridSearchComponent.config.filters.building.onSelect = this.onBuildingSelect.bind(this);
    this.datagridSearchComponent.config.filters.floor.onSelect    = this.onFloorSelect.bind(this);

    // trigger the super's ngOnInit which finishes configuration of the dataGrid component
    super.ngOnInit();
  }

  private constructFilterOptions() {
    const mechanicRequestParams = new RequestParams();
    mechanicRequestParams.addFilterParam({id: 0, key: 'roles', operator: 'eq', value: 'MECHANIC', filterFn: 'substringof', filterOutcome: 'true'});
    mechanicRequestParams.pagination.limit = 0;

    const observables = [
      this.datagridService.getOwnerService().getAll().first(),
      this.datagridService.getCustomerService().getAll().first(),
      this.datagridService.getBuildingService().getAll().first(),
      this.datagridService.getUserService().getAll(mechanicRequestParams).first(),
      this.datagridService.getEnumerationService().get('warranty-status').first(),
      this.datagridService.getEnumerationService().get('channel-location').first(),
      this.datagridService.getEnumerationService().get('throughput-type').first()
    ];

    Observable.forkJoin(observables).subscribe((results: any) => {
      this.datagridSearchComponent.config.filters.owner.options = results[0];
      this.datagridSearchComponent.config.filters.customer.options = results[1];
      this.datagridSearchComponent.config.filters.building.options = results[2].map((building: Building) => {
        building.id = building.buildingId; return building;
      });
      this.datagridSearchComponent.config.filters.mechanic.options = results[3];
      this.datagridSearchComponent.config.filters.warrantyStatus.options = results[4];
      this.datagridSearchComponent.config.filters.location.options = results[5];
      this.datagridSearchComponent.config.filters.throughputType.options = results[6];

      this.onFilterOptionsFinished.next(true);
    });
  }

  public onBuildingSelect() {
    this.datagridSearchComponent.config.filters.floor.value = '';
    this.datagridSearchComponent.config.filters.floor.options = [];
    this.datagridSearchComponent.config.filters.room.value = '';
    this.datagridSearchComponent.config.filters.room.options = [];

    if(this.datagridSearchComponent.config.filters.building.value) {
      this.datagridService.getFloorService().setRoutePrefix(`building/${this.datagridSearchComponent.config.filters.building.value}`);
      this.datagridService.getFloorService().getAll().subscribe((floors: Floor[]) => {
        this.datagridSearchComponent.config.filters.floor.options = floors;
      });
    }
  }

  public onFloorSelect() {
    this.datagridSearchComponent.config.filters.room.value = '';
    this.datagridSearchComponent.config.filters.room.options = [];

    if(this.datagridSearchComponent.config.filters.floor.value) {
      this.datagridService
        .getRoomService()
        .setRoutePrefix(`building/${this.datagridSearchComponent.config.filters.building.value}/floor/${this.datagridSearchComponent.config.filters.floor.value}`);
      this.datagridService.getRoomService().getAll().subscribe((rooms: Room[]) => {
        this.datagridSearchComponent.config.filters.room.options = rooms;
      });
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid-employee-component.ts